import React from 'react';
import { Progress } from '@/components/ui/progress';

interface StockAvailabilityScoreProps {
  percent: number;
}

const getBarColor = (percent: number) => {
  if (percent >= 75) return '[&>div]:bg-green-600';
  if (percent < 30) return '[&>div]:bg-red-500';
  return '[&>div]:bg-yellow-400';
};

const StockAvailabilityScore: React.FC<StockAvailabilityScoreProps> = ({ percent }) => (
  <div className="flex flex-col w-full">
    <div className="flex flex-row justify-between items-center mb-1">
      <span className="text-sm font-semibold text-gray-900">Stock Availability</span>
      <span className="text-sm font-bold text-gray-900">{percent}%</span>
    </div>
    <Progress value={percent} className={`h-2 ${getBarColor(percent)} bg-gray-200`} />
    <div className="mt-2 text-xs text-muted-foreground">Percentage of products in stock</div>
  </div>
);

export default StockAvailabilityScore; 